/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_DescInputs */



/**
* | output |
* | --- |
* | "Snap event start and end times to shot changes" |
*
* @param {Snap_To_Shot_Changes_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_desc = /** @type {((inputs?: Snap_To_Shot_Changes_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner les temps de début et de fin sur les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start- und Endzeiten von Schnappschüssen für Aufnahmeänderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancia gli orari di inizio e fine dell'evento alle modifiche dello scatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снимок времени начала и окончания события для смены ракурса.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar las horas de inicio y finalización de los eventos a los cambios de toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照事件的开始和结束时间与镜头变化相关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの開始時間と終了時間をショットの変更にスナップします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप इवेंट के शुरू और खत्म होने के समय को शॉट में बदलाव के साथ जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste os horários de início e término do evento às alterações de disparo.")
	return /** @type {LocalizedString} */ ("Snap event start and end times to shot changes")
});